import { onDocumentReady } from '../utils/events';

onDocumentReady(() => {
  document.querySelectorAll('[data-contact-tabs]').forEach((tabs) => {
    const tabButtons = Array.from(tabs.querySelectorAll('[data-contact-tab]'));
    const panels = Array.from(tabs.querySelectorAll('[data-contact-panel]'));
    const toggle = tabs.querySelector('.contact-toggle');

    const getButtonFromHash = () =>
      tabButtons.find(
        (button) => button.id && window.location.hash === `#${button.id}`
      );

    const updateHash = (button) => {
      if (!button?.id || window.location.hash === `#${button.id}`) return;
      window.history.replaceState(null, '', `#${button.id}`);
    };

    const scrollToTabs = () => {
      if (!toggle) return;

      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)')
        .matches
        ? 'auto'
        : 'smooth';

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          toggle.scrollIntoView({ behavior, block: 'start' });
        });
      });
    };

    const activateTab = (name, moveFocus = false) => {
      const activeButton = tabButtons.find(
        (button) => button.dataset.contactTab === name
      );
      const activePanel = panels.find(
        (panel) => panel.dataset.contactPanel === name
      );

      if (!activeButton || !activePanel) return;

      tabButtons.forEach((button) => {
        const isActive = button === activeButton;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel !== activePanel;
      });

      if (moveFocus) activeButton.focus();
    };

    tabButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        activateTab(button.dataset.contactTab);
        updateHash(button);
      });

      button.addEventListener('keydown', (event) => {
        let nextIndex;

        if (event.key === 'ArrowRight') {
          nextIndex = (index + 1) % tabButtons.length;
        }
        if (event.key === 'ArrowLeft') {
          nextIndex = (index - 1 + tabButtons.length) % tabButtons.length;
        }
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabButtons.length - 1;
        if (typeof nextIndex === 'undefined') return;

        event.preventDefault();
        const nextButton = tabButtons[nextIndex];
        activateTab(nextButton.dataset.contactTab, true);
        updateHash(nextButton);
      });
    });

    tabs.querySelectorAll('[data-contact-tab-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        activateTab(trigger.dataset.contactTabTrigger, true);
        const activeButton = tabButtons.find(
          (button) =>
            button.dataset.contactTab === trigger.dataset.contactTabTrigger
        );
        updateHash(activeButton);
        scrollToTabs();
      });
    });

    const activateFromHash = (scroll = false) => {
      const button = getButtonFromHash();
      if (!button) return false;

      activateTab(button.dataset.contactTab);
      if (scroll) scrollToTabs();
      return true;
    };

    activateFromHash(true);
    window.addEventListener('hashchange', () => activateFromHash(true));
  });
});
